// removed by extract-text-webpack-plugin
module.exports = {"header":"_1P6_nOOzKiNDrwWMqXpJt4","message-container":"_3700257svZms7eOz29i_G-"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/SiteHeader/styles.css
// module id = 1437
// module chunks = 0